<app-carrousel-gov-co/>
<div class="main-content width-container justify-content-start lg:justify-content-center md:mb-8 mb-3 mt-6 sm:mt-2">
    @for (item of cards; track $index) {
        <p-card class="cards-servicios active-border-gradient">
            <div class="home-container-card">
                <div class="home-container-image">
                    @if (Array.isArray(item.images)) {
                        @for (img of item.images; track $index) {
                            <img [alt]="img.alt" [src]="img.src" [class]="img.class" class="cursor-pointer"
                                 decoding="auto" draggable="false">
                        }
                    } @else {
                        <img [alt]="item.images.alt" [src]="item.images.src"
                             decoding="auto" draggable="false">
                    }
                </div>
                <div class="home-body-card">
                    <h1 class="title-blue font-weight-regular font-primary my-0 text-left animated-text ">{{ item.title }}</h1>
                    <p class="text-gray text-left font-primary my-0 md:my-3 animated-text">{{ item.description }} </p>
                </div>

                @if (item.button) {
                    <button pButton [class]="item.button.class" (click)="item.button.onClick($event)">
                        <span *ngIf="item.button.label" class="font-15">{{ item.button.label }}</span>
                        <i [class]="item.button.icon" *ngIf="item.button.icon"></i>
                    </button>
                }
            </div>

        </p-card>
    }
</div>
<app-sede-electronica-noticias/>
